import { render } from "./EmploymentForm.vue?vue&type=template&id=70b2c366&scoped=true"
import script from "./EmploymentForm.vue?vue&type=script&lang=js"
export * from "./EmploymentForm.vue?vue&type=script&lang=js"

import "./EmploymentForm.vue?vue&type=style&index=0&id=70b2c366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b2c366"]])

export default __exports__